import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useDialogState } from "@/hooks/use-dialog-state";

export const AssetSizeDialog = () => {
  const { dialog, closeDialog } = useDialogState();

  return (
    <AlertDialog open={dialog?.name === "asset-size"}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Asset Exceeds Max Size</AlertDialogTitle>
          <AlertDialogDescription>
            The image or video uploaded exceeds the maximum file size. Images
            are limited to 10MB and product videos are limited to 200MB. Videos
            for the webpage can be up to 30GB.
            <br />
            <br />
            Please resize or choose another file.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button onClick={closeDialog}>Close</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
